import { cloneDeep } from 'lodash'
import { SORTING } from '../../components/Insights/consts'
import { DEFAULT_CHART_PREFERENCES } from '../../components/screens/Explorer/DrawerTabs/StyleTab/styleConsts'

export const backwardsFlag = '2.1.8'

/**
 * Returns the default data configuration.
 * These properties affect what data is fetched from the API.
 */
export const getDefaultDataConfig = () => ({
    selectedItems: [],
    categoryAxis: 'Time',
    drillAttribute: undefined,
    filter: null,
    savedFilter: null,
    worksheetID: undefined,
    rangeName: undefined,
    sheetName: undefined,
    selectedWorksheetName: undefined,
    worksheetColumns: [],
    selectedTableColumns: [],
    selectedTableKpis: [],
    selectedTables: [],
    usedDrillAttributes: [],
    allowedKPIs: undefined,
    allowedReportSeriesTables: undefined,
})

/**
 * Returns the default query configuration.
 * These properties affect how data is aggregated/filtered.
 */
export const getDefaultQueryConfig = () => ({
    period: 'Monthly',
    timeRange: 'All',
    calendarType: 'Rolling',
    from: null,
    to: null,
    fromPeriod: null,
    toPeriod: null,
    sortColumns: [{ column: '', order: SORTING.NAT }],
    displayRows: 'All',
    tableTimeSeries: true,
    disableTimeSeries: false,
    activePrompts: [],
})

/**
 * Returns the default view configuration.
 * These properties only affect rendering, not data fetching.
 */
export const getDefaultViewConfig = () => ({
    chartTitle: '',
    view: 'chart',
    seriesType: 'column',
    stacked: true,
    seriesTypeMap: new Map(),
    selectedDates: new Map(),
    styleOverrides: cloneDeep(DEFAULT_CHART_PREFERENCES),
    themeID: undefined,
    kpiCompareType: 'percentage',
    kpiCompareTarget: undefined,
    metricsOrder: [],
    nonPivotColumnsOrder: [],
    pivotColumnsOrder: [],
    tableState: {
        nonPivotState: { rowGroupCols: [] },
        pivotState: { rowGroupCols: [], pivotCols: [] },
        pinnedCols: [],
    },
})

/**
 * Returns the full default configuration (all three merged).
 * Used for backwards compatibility with code expecting single config object.
 */
export const getDefaultConfig = () => ({
    ...getDefaultDataConfig(),
    ...getDefaultQueryConfig(),
    ...getDefaultViewConfig(),
    loading: false,
    backwardsFlag,
})
